
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"27.384","height":"36.082"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 5785"}},[_c('g',{attrs:{"data-name":"Grupo 5776"}},[_c('path',{attrs:{"data-name":"Unión 287","d":"M.65 36.082a.65.65 0 01-.651-.65V.65A.65.65 0 01.65 0h16.482a.65.65 0 01.455.185l9.6 9.388a.65.65 0 01.2.465V35.431a.65.65 0 01-.651.65zm.65-1.3h24.779V10.723h-8.964a.65.65 0 01-.65-.651V1.299H1.296zM17.769 9.423h7.373l-7.373-7.226z"}})]),_c('path',{attrs:{"data-name":"Rectángulo 8007 - Contorno","d":"M4.229 17.397h18.925a.65.65 0 01.65.65v12.846a.65.65 0 01-.65.65H4.229a.65.65 0 01-.65-.65V18.047a.65.65 0 01.65-.65zm18.275 1.3H4.879v11.55h17.625z"}}),_c('path',{attrs:{"data-name":"Unión 286","d":"M12.101 28.144a.652.652 0 01-.35-.577v-6.193a.652.652 0 01.35-.577.65.65 0 01.673.045l4.416 3.1a.65.65 0 01.277.533.65.65 0 01-.277.532l-4.416 3.1a.652.652 0 01-.374.118.653.653 0 01-.299-.081z"}})])])
          )
        }
      }
    